// import React, { useState } from 'react'
// import DashboardLayout from '../../../components/DashboardLayout'
// import { Link, useNavigate } from 'react-router-dom'

// // import { useState } from "react";
// // import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
// // import "leaflet/dist/leaflet.css";
// import { Search, Filter } from "lucide-react";
// // import L from "leaflet";

// // Fix marker icon issue in Leaflet (default icons not bundling correctly)
// // import "leaflet/dist/images/marker-shadow.png";
// import FleetrifyCard from '../../../components/Card';
// import { fleetrifyIcons } from '../../../assets/icons/icons';
// // delete (L.Icon.Default.prototype as any)._getIconUrl;
// // L.Icon.Default.mergeOptions({
// //     iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
// //     iconUrl: require("leaflet/dist/images/marker-icon.png"),
// //     shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// // });


// type OrderStatus = "Completed" | "In-transit" | "Pending" | "Cancelled";

// interface Order {
//     id: number;
//     service: string;
//     pickup: string;
//     dropoff: string;
//     date: string;
//     status: OrderStatus;
//     pickupCoords: [number, number];
//     dropoffCoords: [number, number];
// }

// const orders: Order[] = [
//     {
//         id: 53767,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "Completed",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.975, 77.6],
//     },
//     {
//         id: 53768,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "In-transit",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.982, 77.62],
//     },
//     {
//         id: 53769,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "Cancelled",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.965, 77.58],
//     },
//     {
//         id: 53770,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "Pending",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.98, 77.59],
//     },
//     {
//         id: 53771,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "In-transit",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.982, 77.62],
//     },
//     {
//         id: 53772,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "Cancelled",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.965, 77.58],
//     },
//     {
//         id: 53773,
//         service: "Transportation",
//         pickup: "123 Main St, Lagos",
//         dropoff: "75 Market St, Lagos",
//         date: "12 May",
//         status: "Pending",
//         pickupCoords: [12.9716, 77.5946],
//         dropoffCoords: [12.98, 77.59],
//     },
// ];

// const statusColors: Record<OrderStatus, string> = {
//     Completed: "bg-green-100 text-green-700 border-green-700",
//     "In-transit": "bg-blue-100 text-blue-700  border-blue-700",
//     Pending: "bg-yellow-100 text-yellow-700  border-yellow-700",
//     Cancelled: "bg-red-100 text-red-700  border-red-700",
// };


// const ViewOrder = () => {
//     const navigate = useNavigate()
//     const [selectedOrder, setSelectedOrder] = useState<Order | null>(orders[0]);
//     return (
//         <DashboardLayout
//             title="View Order"
//             pagePath={
//                 <div className='text-sm text-gray-500 '>
//                     <button onClick={() => navigate(-1)} className=' cursor-pointer'>Orders</button> {">"} <span className='text-[#143887] font-bold'>View Order</span>
//                 </div>
//             }
//         >
//             <FleetrifyCard cardContainerClass=" grid grid-cols-12 mt-5 gap-4 mb-10">
//                 {/* Sidebar */}
//                 <div className="col-span-4 flex flex-col max-h-[calc(100vh-100px)]">
//                     {/* Header */}
//                     <div className="flex items-center justify-between p-3">
//                         <h2 className="font-semibold">
//                             Active Orders <span className="text-green-600">- {orders.length}</span>
//                         </h2>
//                     </div>

//                     {/* Search + Filter */}
//                     <div className="flex items-center gap-2 px-3 py-4">
//                         <div
//                             className="grid relative flex-1 place-items-center border py-1 rounded-3xl border-[#E7E9EE]"
//                         >
//                             <input
//                                 placeholder="Search"
//                                 className="w-full text-sm placeholder:text-[#BDBDBD] font-medium outline-none  placeholder:text-sm border-none rounded-[30px] bg-[#FFFFFF] px-4 py-2"
//                             />
//                             <figure className="absolute right-6">
//                                 <Search className="text-[#828282] h-5 w-5 opacity-100" />
//                             </figure>
//                         </div>
//                         <button className="p-2 rounded-md hover:bg-gray-50">
//                             {fleetrifyIcons.searchFilterIcon}
//                         </button>
//                     </div>

//                     {/* Orders List - scrollable only */}
//                     <div className="flex-1 overflow-y-auto custom-scrollbar px-3 pb-3">
//                         <div className="space-y-6">
//                             {orders.map((order) => (
//                                 <div
//                                     key={order.id}
//                                     onClick={() => setSelectedOrder(order)}
//                                     className={`cursor-pointer bg-gray-50 border space-y-4 shadow border-[#E0E0E0] rounded-md p-3 transition ${selectedOrder?.id === order.id
//                                             ? "shadow border-l-4 border-l-[#13532E] bg-blue-50"
//                                             : ""
//                                         }`}
//                                 >
//                                     <div className="flex justify-between items-center mb-2">
//                                         <p className="text-sm text-[#00032A] font-medium">
//                                             ID #{order.id}
//                                         </p>
//                                         <span
//                                             className={`px-4 text-xs font-medium rounded-[24px] py-[5px] border ${statusColors[order.status]}`}
//                                         >
//                                             {order.status}
//                                         </span>
//                                     </div>
//                                     <p className="text-sm text-gray-600">{order.service}</p>
//                                     <div className="mt-2 space-y-3 text-xs text-[#0D160B]">
//                                         <p>
//                                             {order.date} <span>•</span> {order.pickup}
//                                         </p>
//                                         <p>
//                                             {order.date} <span>•</span> {order.dropoff}
//                                         </p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>


//                 {/* Map Area */}
//                 {/* <div className="col-span-8 border p-2 rounded-xl overflow-hidden shadow">
//                     {selectedOrder ? (
//                         <div className="relative flex-1 h-full">
//                             <MapContainer
//                                 center={selectedOrder.pickupCoords}
//                                 zoom={13}
//                                 scrollWheelZoom={true}
//                                 className="h-full w-full"
//                             >
//                                 <TileLayer
//                                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                                     attribution="© OpenStreetMap contributors"
//                                 />
//                                 <Marker position={selectedOrder.pickupCoords}>
//                                     <Popup>{selectedOrder.pickup}</Popup>
//                                 </Marker>
//                                 <Marker position={selectedOrder.dropoffCoords}>
//                                     <Popup>{selectedOrder.dropoff}</Popup>
//                                 </Marker>
//                                 <Polyline
//                                     positions={[selectedOrder.pickupCoords, selectedOrder.dropoffCoords]}
//                                     color="blue"
//                                 />
//                             </MapContainer>
//                             <div className="absolute z-[9999] inset-0 bg-blue-500 opacity-20 pointer-events-none" />
//                         </div>

//                     ) : (
//                         <div className="w-full h-full flex items-center justify-center text-gray-400">
//                             Select an order to view its map
//                         </div>
//                     )}
//                 </div> */}
//             </FleetrifyCard>

//         </DashboardLayout>
//     )
// }

// export default ViewOrder


import React, { useEffect, useMemo, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import { RefreshCw, CheckCircle, XCircle, AlertTriangle, X, ChevronLeft, ChevronRight, ArrowLeftRight } from 'lucide-react'
import DashboardLayout from '../../../components/DashboardLayout'
import { useNavigate, useParams } from 'react-router-dom'
import FleetrifyCard from '../../../components/Card'
import { useGetOrderByIdQuery, useUpdateOrderStatusMutation } from '../../../redux/services/orders'
import { useGetCompanyInfoQuery } from '../../../redux/services/settingsApi'
import { baseApi } from '../../../redux/services/baseApi'
import { useAppDispatch } from '../../../redux/services/store'
import { createEcho } from '../../../utils/echo'
import { toast } from 'sonner'
import { PaymentBadges } from '../../../components/PaymentBadges'
import { CounterOffer, formatNaira, isDayToDayOrder, useDispatchNegotiation } from './negotiation'
import CounterOrderModal from './components/CounterOrderModal'
import RejectOrderModal from './components/RejectOrderModal'
import NegotiationCard from './components/NegotiationCard'
import {
    NEGOTIATION_HINT,
    negotiationHint,
    NegotiationRequest,
    NegotiationRequestBadge,
    NegotiationRequestNotice,
    isNegotiationRequestOpen,
    showNegotiationBadge,
} from '../../../components/NegotiationRequest'
import { FLEETRIFYROUTEPATH } from '../../../routes/routesPath'

type OrderStatus = "delivered" | "in_progress" | "pending" | "cancelled" | "accepted" | "out_for_delivery" | "failed" | "in_transit" | "picked_up" | "counter_sent" | "customer_countered" | string

interface OrderHistoryEntry {
    id: number | string
    status: OrderStatus
    title?: string
    note?: string
    created_at?: string
    updated_at?: string
    order_type?: string
    pickup_location?: string
    delivery_location?: string
    order_number?: string
}

interface Customer {
    id: string
    name: string
    phone: string
    email: string
}

interface Driver {
    id: string
    name: string
    phone?: string
    email?: string
}

interface OrderDetailInfo {
    id: string
    latitude?: string
    longitude?: string
    pickup_location?: string
    destination?: string
    pickup_date_type?: string
    pickup_date?: string
    pickup_time?: string
    vehicle_type?: string
    package_type?: string | null
    package_weight?: string | null
    package_size?: string | null
    delivery_note?: string | null
    recipient_name?: string
    recipient_phone?: string
    recipient_additional_info?: string | null
    created_at?: string
    updated_at?: string
    dest_lat?: string | null
    dest_lng?: string | null
}

interface OrderImage {
    id: string | number
    service_order_id?: string
    image_url: string
    created_at?: string
    updated_at?: string
}

interface Order {
    id: number | string
    order_number?: string
    order_type?: string
    price?: string
    payment_status?: string
    // Snapshot of the company's "Payment Collection" setting AT THE TIME this
    // order was placed — locked in per order, independent of the company's
    // current setting.
    payment_preference?: string
    // "cash" or "wallet" — which method this order is being paid with.
    payment_method?: string
    // Only meaningful when payment_method === "cash": null until the driver
    // acts on it, then true/false. Always null for wallet orders.
    cash_collected?: boolean | null
    cash_collected_at?: string | null
    // Set when the customer (not the driver) claims to have paid in cash —
    // an intermediate state while waiting on the driver's own confirmation.
    customer_confirmed_cash_at?: string | null
    pickup_location?: string
    delivery_location?: string
    created_at?: string
    updated_at?: string
    status: OrderStatus
    customer?: Customer | null
    driver?: Driver | null
    order_detail?: OrderDetailInfo | null
    images?: OrderImage[]
    review?: unknown
    status_histories?: OrderHistoryEntry[]
    // Day-to-day only: the latest offer from each side.
    counter_offer?: CounterOffer | null
    // Customer tapped "Negotiate" (day-to-day and relocation); null otherwise.
    negotiation_request?: NegotiationRequest | null
}

// const orders: Order[] = [
//     { id: 53767, order_number: "ORD-53767", order_type: "Transportation", pickup_location: "123 Main St, Lagos", dropoff_location: "75 Market St, Lagos", created_at: "2023-05-12T09:00:00Z", status: "delivered", pickupCoords: [12.9716, 77.5946], dropoffCoords: [12.975, 77.6] },
//     { id: 53768, order_number: "ORD-53768", order_type: "Transportation", pickup_location: "123 Main St, Lagos", dropoff_location: "75 Market St, Lagos", created_at: "2023-05-12T10:00:00Z", status: "in_progress", pickupCoords: [12.9716, 77.5946], dropoffCoords: [12.982, 77.62] },
//     { id: 53769, order_number: "ORD-53769", order_type: "Transportation", pickup_location: "123 Main St, Lagos", dropoff_location: "75 Market St, Lagos", created_at: "2023-05-12T11:00:00Z", status: "delivered", pickupCoords: [12.9716, 77.5946], dropoffCoords: [12.965, 77.58] },
//     { id: 53770, order_number: "ORD-53770", order_type: "Transportation", pickup_location: "123 Main St, Lagos", dropoff_location: "75 Market St, Lagos", created_at: "2023-05-12T12:00:00Z", status: "pending", pickupCoords: [12.9716, 77.5946], dropoffCoords: [12.98, 77.59] },
// ]

const activeStatuses = new Set(["in_progress", "accepted", "out_for_delivery", "in_transit", "picked_up", "pending", "counter_sent", "customer_countered"])

const statusColors: Record<OrderStatus, string> = {
    delivered: "bg-green-100 text-green-800 border border-green-700",
    "in_progress": "bg-blue-100 text-blue-800 border border-blue-700",
    pending: "bg-yellow-100 text-yellow-800 border border-yellow-700",
    cancelled: "bg-red-100 text-red-800 border border-red-700",
    rejected: "bg-red-100 text-red-800 border border-red-700",
    accepted: "bg-indigo-100 text-indigo-800 border border-indigo-700",
    out_for_delivery: "bg-purple-100 text-purple-800 border border-purple-700",
    failed: "bg-red-100 text-red-800 border border-red-700",
    in_transit: "bg-blue-100 text-blue-800 border border-blue-700",
    picked_up: "bg-teal-100 text-teal-800 border border-teal-700",
    counter_sent: "bg-amber-100 text-amber-800 border border-amber-700",
    customer_countered: "bg-fuchsia-100 text-fuchsia-800 border border-fuchsia-700",
}

// Statuses that PATCH /orders/{id}/status blocks with a 400 when the company
// requires payment before delivery and the order hasn't been paid for yet.
const paymentGatedStatuses = new Set<OrderStatus>([
    "in_progress",
    "picked_up",
    "in_transit",
    "out_for_delivery",
    "delivered",
])

const statusUpdateOptions: Record<OrderStatus, OrderStatus[]> = {
    pending: ["accepted", "picked_up", "out_for_delivery", "in_transit", "delivered", "cancelled"],
    // Once an order has moved past "pending" it can never go back to "pending"
    // or "accepted" — only forward-moving statuses are valid update targets.
    "in_progress": ["picked_up", "out_for_delivery", "in_transit", "delivered", "cancelled"],
    delivered: [],
    cancelled: [],
    rejected: [],
    accepted: ["picked_up", "out_for_delivery", "in_transit", "delivered", "cancelled"],
    out_for_delivery: ["in_transit", "delivered", "cancelled"],
    failed: [],
    in_transit: ["delivered", "cancelled"],
    picked_up: ["out_for_delivery", "in_transit", "delivered", "cancelled"],
}

const humanizeStatus = (status: string) => {
    switch (status) {
        case "in_progress":
            return "In Progress"
        case "delivered":
            return "Delivered"
        case "cancelled":
            return "Cancelled"
        case "pending":
            return "Pending"
        default:
            return status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    }
}

const BRAND = "#143887"

const BackButton = ({ onClick }: { onClick: () => void }) => (
    <button
        onClick={onClick}
        title="Back to Orders"
        style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "6px 14px 6px 10px",
            borderRadius: 8,
            border: `1.5px solid ${BRAND}`,
            background: "#fff",
            color: BRAND,
            fontWeight: 600,
            fontSize: 13,
            cursor: "pointer",
            transition: "background 0.15s, color 0.15s",
            whiteSpace: "nowrap",
        }}
        onMouseEnter={e => {
            (e.currentTarget as HTMLButtonElement).style.background = BRAND
                ; (e.currentTarget as HTMLButtonElement).style.color = "#fff"
        }}
        onMouseLeave={e => {
            (e.currentTarget as HTMLButtonElement).style.background = "#fff"
                ; (e.currentTarget as HTMLButtonElement).style.color = BRAND
        }}
    >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" />
            <path d="M12 19l-7-7 7-7" />
        </svg>
        {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 mr-2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 12H5m0 0l7-7m-7 7l7 7"
            />
          </svg> */}
        Back to Orders
    </button>
)

const MapPlaceholder = () => (
    <div className="relative rounded-xl overflow-hidden" style={{ height: 200, background: "linear-gradient(135deg, #E6F1FB 0%, #EAF3DE 100%)" }}>
        <svg className="absolute inset-0 w-full h-full opacity-30" viewBox="0 0 600 200" preserveAspectRatio="xMidYMid slice">
            {[50, 100, 150].map(y => <line key={y} x1="0" y1={y} x2="600" y2={y} stroke={BRAND} strokeWidth="0.5" />)}
            {[100, 200, 300, 400, 500].map(x => <line key={x} x1={x} y1="0" x2={x} y2="200" stroke={BRAND} strokeWidth="0.5" />)}
            <path d="M50 100 Q200 60 350 110 Q450 140 550 90" fill="none" stroke="#185FA5" strokeWidth="3" strokeLinecap="round" />
            {[80, 280, 480].map(x => <line key={x} x1={x} y1="20" x2={x} y2="185" stroke="#185FA5" strokeWidth="1.5" />)}
            {[70, 145].map(y => <line key={y} x1="0" y1={y} x2="600" y2={y} stroke="#185FA5" strokeWidth="1" />)}
        </svg>
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 600 200" preserveAspectRatio="xMidYMid meet">
            <path d="M120 145 C200 80,350 80,460 80" fill="none" stroke={BRAND} strokeWidth="3" strokeDasharray="8,4" strokeLinecap="round" />
            <circle cx="120" cy="145" r="10" fill={BRAND} />
            <circle cx="120" cy="145" r="4" fill="white" />
            <circle cx="460" cy="80" r="10" fill="#166534" />
            <circle cx="460" cy="80" r="4" fill="white" />
        </svg>
        <div className="absolute bottom-3 left-3 flex gap-3 bg-white rounded-lg px-3 py-1.5 text-xs border border-gray-200">
            <span className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full inline-block" style={{ background: BRAND }} />
                Pickup
            </span>
            <span className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full inline-block bg-green-800" />
                Dropoff
            </span>
        </div>
    </div>
)

const formatDateTime = (value?: string) => {
    if (!value) return "Unknown"
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
}

const formatTimeOnly = (value?: string) => {
    if (!value) return "Unknown"
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
}

// Cap the thumbnail grid so a large batch of uploads doesn't blow out the layout —
// the last visible tile gets a "+N" overlay; the lightbox still cycles through all of them.
const PACKAGE_IMAGES_PREVIEW_COUNT = 9

const DetailRow = ({ label, value }: { label: string; value?: string | null }) => (
    <div className="flex flex-col gap-0.5">
        <p className="text-[11px] text-gray-400">{label}</p>
        <p className="text-sm font-medium text-gray-800">{value || "—"}</p>
    </div>
)

const SectionCard = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div className="rounded-lg p-4 border border-gray-100 bg-gray-50">
        <p className="text-[11px] text-gray-400 font-medium mb-3 uppercase tracking-wide">{title}</p>
        {children}
    </div>
)

const OrderDetail = ({
    order,
    histories,
    selectedHistory,
    negotiation,
}: {
    order: Order
    histories: OrderHistoryEntry[]
    selectedHistory: OrderHistoryEntry | null
    negotiation?: React.ReactNode
}) => {
    const fallbackHistory: OrderHistoryEntry = {
        id: order.id,
        status: order.status,
        title: order.order_type || `Order ${order.status}`,
        created_at: order.created_at,
        pickup_location: order.pickup_location,
        delivery_location: order.delivery_location,
        order_number: order.order_number,
    }

    const activeHistory = selectedHistory ?? histories[0] ?? fallbackHistory
    const timeline = histories.length ? histories : [fallbackHistory]
    const od = order.order_detail
    const images = order.images ?? []

    const [lightboxIndex, setLightboxIndex] = useState<number | null>(null)

    useEffect(() => {
        setLightboxIndex(null)
    }, [order.id])

    useEffect(() => {
        if (lightboxIndex === null) return

        document.body.style.overflow = "hidden"

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") setLightboxIndex(null)
            if (event.key === "ArrowLeft") setLightboxIndex((i) => (i === null ? null : (i - 1 + images.length) % images.length))
            if (event.key === "ArrowRight") setLightboxIndex((i) => (i === null ? null : (i + 1) % images.length))
        }

        window.addEventListener("keydown", handleKeyDown)
        return () => {
            document.body.style.overflow = ""
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [lightboxIndex, images.length])

    const formatPickupDateTime = () => {
        if (!od?.pickup_date) return "—"
        const date = new Date(od.pickup_date)
        const dateStr = date.toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" })
        return od.pickup_time ? `${dateStr} at ${od.pickup_time}` : dateStr
    }

    return (
        <div className="space-y-4">
            <MapPlaceholder />

            {/* Price + Payment status */}
            <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-[11px] text-gray-400 mb-1">Order Price</p>
                    <p className="text-sm font-semibold text-gray-800">
                        {order.price ? `₦${Number(order.price).toLocaleString("en-NG", { minimumFractionDigits: 2 })}` : "—"}
                    </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-[11px] text-gray-400 mb-1">Payment</p>
                    {order.payment_status || order.payment_preference || order.payment_method ? (
                        <div className="space-y-1">
                            <PaymentBadges
                                paymentStatus={order.payment_status}
                                paymentPreference={order.payment_preference}
                                paymentMethod={order.payment_method}
                                cashCollected={order.cash_collected}
                                customerConfirmedCashAt={order.customer_confirmed_cash_at}
                            />
                            {order.payment_method === "cash" && order.customer_confirmed_cash_at && (
                                <p className="text-[10px] text-gray-400">
                                    Customer confirmed {formatDateTime(order.customer_confirmed_cash_at)}
                                </p>
                            )}
                            {order.payment_method === "cash" && order.cash_collected_at && (
                                <p className="text-[10px] text-gray-400">
                                    Driver confirmed {formatDateTime(order.cash_collected_at)}
                                </p>
                            )}
                        </div>
                    ) : (
                        <p className="text-sm font-medium text-gray-800">—</p>
                    )}
                </div>
            </div>

            {negotiation}

            {/* Info grid */}
            <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-[11px] text-gray-400 mb-1">Service type</p>
                    <p className="text-sm font-medium text-gray-800">{(order.order_type || "Unknown").toString().replace(/_/g, " ").replace(/\b\w/g, (char: string) => char.toUpperCase())}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-[11px] text-gray-400 mb-1">Date</p>
                    <p className="text-sm font-medium text-gray-800">{formatDateTime(activeHistory?.created_at || order.created_at)}</p>
                </div>
            </div>

            {/* Route */}
            <SectionCard title="Route">
                <div className="flex gap-3">
                    <div className="flex flex-col items-center pt-1">
                        <span className="w-2.5 h-2.5 rounded-full" style={{ background: BRAND }} />
                        <span className="w-0.5 flex-1 my-1 bg-gray-300" style={{ minHeight: 28 }} />
                        <span className="w-2.5 h-2.5 rounded-full bg-green-700" />
                    </div>
                    <div className="flex flex-col gap-4 flex-1">
                        <div>
                            <p className="text-[11px] text-gray-400">Pickup</p>
                            <p className="text-sm font-medium text-gray-800">{od?.pickup_location || activeHistory.pickup_location || order.pickup_location || "Not specified"}</p>
                        </div>
                        <div>
                            <p className="text-[11px] text-gray-400">Dropoff</p>
                            <p className="text-sm font-medium text-gray-800">{od?.destination || activeHistory.delivery_location || order.delivery_location || "Not specified"}</p>
                        </div>
                    </div>
                </div>
            </SectionCard>

            {/* Delivery details */}
            {od && (
                <SectionCard title="Delivery Details">
                    <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                        <DetailRow label="Vehicle Type" value={od.vehicle_type ? od.vehicle_type.replace(/\b\w/g, c => c.toUpperCase()) : null} />
                        <DetailRow label="Pickup Schedule" value={formatPickupDateTime()} />
                        <DetailRow label="Pickup Type" value={od.pickup_date_type ? od.pickup_date_type.replace(/\b\w/g, c => c.toUpperCase()) : null} />
                        <DetailRow label="Package Type" value={od.package_type} />
                        <DetailRow label="Package Weight" value={od.package_weight} />
                        <DetailRow label="Package Size" value={od.package_size} />
                    </div>
                    {od.delivery_note && (
                        <div className="mt-3 pt-3 border-t border-gray-200">
                            <p className="text-[11px] text-gray-400 mb-1">Delivery Note</p>
                            <p className="text-sm text-gray-700">{od.delivery_note}</p>
                        </div>
                    )}
                </SectionCard>
            )}

            {/* Package images uploaded by the customer */}
            {images.length > 0 && (
                <SectionCard title={`Package Images${images.length > 1 ? ` (${images.length})` : ""}`}>
                    <div className="grid grid-cols-4 sm:grid-cols-5 gap-2">
                        {images.slice(0, PACKAGE_IMAGES_PREVIEW_COUNT).map((image, index) => {
                            const isLastPreviewTile = index === PACKAGE_IMAGES_PREVIEW_COUNT - 1
                            const remainingCount = images.length - PACKAGE_IMAGES_PREVIEW_COUNT

                            return (
                                <button
                                    key={image.id}
                                    type="button"
                                    onClick={() => setLightboxIndex(index)}
                                    className="relative aspect-square rounded-md overflow-hidden border border-gray-200 hover:opacity-90 transition focus:outline-none focus:ring-2 focus:ring-[#143887]"
                                >
                                    <img
                                        src={image.image_url}
                                        alt={`Package ${index + 1}`}
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                    {isLastPreviewTile && remainingCount > 0 && (
                                        <span className="absolute inset-0 bg-black/60 flex items-center justify-center text-white text-sm font-semibold">
                                            +{remainingCount}
                                        </span>
                                    )}
                                </button>
                            )
                        })}
                    </div>
                </SectionCard>
            )}

            {lightboxIndex !== null && images[lightboxIndex] && (
                <div
                    className="fixed inset-0 z-[10030] flex items-center justify-center bg-black/85 backdrop-blur-sm px-4"
                    onClick={() => setLightboxIndex(null)}
                >
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setLightboxIndex(null) }}
                        className="absolute top-4 right-4 text-white/80 hover:text-white"
                        aria-label="Close"
                    >
                        <X size={28} />
                    </button>

                    {images.length > 1 && (
                        <>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setLightboxIndex((i) => (i === null ? null : (i - 1 + images.length) % images.length))
                                }}
                                className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-2"
                                aria-label="Previous image"
                            >
                                <ChevronLeft size={32} />
                            </button>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setLightboxIndex((i) => (i === null ? null : (i + 1) % images.length))
                                }}
                                className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-2"
                                aria-label="Next image"
                            >
                                <ChevronRight size={32} />
                            </button>
                        </>
                    )}

                    <img
                        src={images[lightboxIndex].image_url}
                        alt={`Package ${lightboxIndex + 1}`}
                        className="max-h-[85vh] max-w-full rounded-lg object-contain"
                        onClick={(e) => e.stopPropagation()}
                    />

                    {images.length > 1 && (
                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/80 text-xs">
                            {lightboxIndex + 1} / {images.length}
                        </div>
                    )}
                </div>
            )}

            {/* Recipient */}
            {od && (od.recipient_name || od.recipient_phone) && (
                <SectionCard title="Recipient">
                    <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                        <DetailRow label="Name" value={od.recipient_name} />
                        <DetailRow label="Phone" value={od.recipient_phone} />
                        {od.recipient_additional_info && (
                            <div className="col-span-2">
                                <DetailRow label="Additional Info" value={od.recipient_additional_info} />
                            </div>
                        )}
                    </div>
                </SectionCard>
            )}

            {/* Customer */}
            {order.customer && (
                <SectionCard title="Customer">
                    <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                        <DetailRow label="Name" value={order.customer.name} />
                        <DetailRow label="Phone" value={order.customer.phone} />
                        <div className="col-span-2">
                            <DetailRow label="Email" value={order.customer.email} />
                        </div>
                    </div>
                </SectionCard>
            )}

            {/* Driver */}
            <SectionCard title="Driver">
                {order.driver ? (
                    <div className="grid grid-cols-2 gap-x-4 gap-y-3">
                        <DetailRow label="Name" value={order.driver.name} />
                        <DetailRow label="Phone" value={order.driver.phone} />
                        {order.driver.email && (
                            <div className="col-span-2">
                                <DetailRow label="Email" value={order.driver.email} />
                            </div>
                        )}
                    </div>
                ) : (
                    <p className="text-sm text-gray-400">No driver assigned yet</p>
                )}
            </SectionCard>

            {/* Timeline */}
            <SectionCard title="Timeline">
                {timeline.map((event, index) => {
                    const isActive = event.id === activeHistory?.id
                    return (
                        <motion.div
                            key={event.id}
                            className="flex gap-3"
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: index * 0.07, duration: 0.25 }}
                        >
                            <div className="flex flex-col items-center">
                                <motion.span
                                    className="w-2.5 h-2.5 rounded-full mt-0.5 flex-shrink-0"
                                    style={{ background: isActive ? BRAND : "#D1D5DB" }}
                                    animate={isActive && activeStatuses.has(event.status)
                                        ? { scale: [1, 1.35, 1] }
                                        : { scale: 1 }}
                                    transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}
                                />
                                {index < timeline.length - 1 && (
                                    <span className="w-0.5 bg-gray-200" style={{ height: 24, margin: "2px 0" }} />
                                )}
                            </div>
                            <div className="pb-1">
                                <p className={`text-sm ${isActive ? "text-gray-800" : "text-gray-400"}`}>
                                    {humanizeStatus(event.status)}
                                </p>
                                <p className="text-[11px] text-gray-400">{formatTimeOnly(event.created_at)}</p>
                            </div>
                        </motion.div>
                    )
                })}
            </SectionCard>
        </div>
    )
}

const ViewOrder = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { orderId } = useParams<{ orderId: string }>()
    const [selectedHistory, setSelectedHistory] = useState<OrderHistoryEntry | null>(null)
    const [mobileView, setMobileView] = useState<"list" | "detail">("list")
    const lastKnownStatusRef = useRef<string | undefined>(undefined)

    const { data: fetchedOrder, isLoading: isOrderLoading, refetch: refetchOrder } = useGetOrderByIdQuery(
        { id: orderId ?? "" },
        { skip: !orderId }
    )
    const { data: companyInfoData } = useGetCompanyInfoQuery()
    const companyId = companyInfoData?.data?.companyInfo?.id
    const [selectedStatus, setSelectedStatus] = useState<OrderStatus>("")
    const [updateOrderStatus, { isLoading: isUpdating }] = useUpdateOrderStatusMutation()

    const fetchedOrderPayload =
        fetchedOrder?.data?.order ?? fetchedOrder?.data ?? fetchedOrder

    const activeOrder = fetchedOrderPayload as Order | undefined

    // Live payment_status / status changes (e.g. the customer paying on mobile)
    // arrive over pusher — refetch this order when its own event fires.
    useEffect(() => {
        const token = localStorage.getItem("token")
        if (!token || !companyId || !orderId) return

        const echo = createEcho(token)
        const channelName = `company.${companyId}.orders`
        const channel = echo.private(channelName)

        const handleStatusUpdated = (event: any) => {
            if (String(event?.id ?? event?.order_id) !== String(orderId)) return
            dispatch(baseApi.util.invalidateTags(["Orders"]))
        }

        channel.listen(".order.status.updated", handleStatusUpdated)

        return () => {
            channel.stopListening(".order.status.updated")
        }
    }, [companyId, orderId, dispatch])

    const orderHistories = useMemo<OrderHistoryEntry[]>(() => {
        if (!activeOrder) {
            return []
        }

        const histories = activeOrder.status_histories?.slice().reverse() ?? []

        const fallbackHistory: OrderHistoryEntry = {
            id: activeOrder.id,
            status: activeOrder.status,
            title: activeOrder.order_type || `Order ${activeOrder.status}`,
            created_at: activeOrder.created_at,
            pickup_location: activeOrder.pickup_location,
            delivery_location: activeOrder.delivery_location,
            order_number: activeOrder.order_number,
        }

        return histories.length ? histories : [fallbackHistory]
    }, [activeOrder])

    useEffect(() => {
        if (orderHistories.length === 0) return

        const statusChanged = lastKnownStatusRef.current !== activeOrder?.status
        lastKnownStatusRef.current = activeOrder?.status

        if (!selectedHistory || statusChanged) {
            const currentStatusHistory = orderHistories.find((history) => {
                if (!activeOrder) return false
                if (history.status !== activeOrder.status) return false
                return (
                    history.created_at === activeOrder.updated_at ||
                    history.created_at === activeOrder.created_at
                )
            })
            setSelectedHistory(currentStatusHistory ?? orderHistories[0])
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeOrder, orderHistories])

    const isDayToDay = isDayToDayOrder(activeOrder)
    const negotiation = useDispatchNegotiation(orderId, isDayToDay)
    const [showCounterModal, setShowCounterModal] = useState(false)
    const [showRejectModal, setShowRejectModal] = useState(false)

    // For day-to-day orders /dispatch-orders/{id} is the source of truth for
    // status, price and the counter offer.
    const orderToRender: Order = activeOrder
        ? {
            ...activeOrder,
            ...(negotiation.order && {
                status: negotiation.order.status,
                price: negotiation.order.price,
                counter_offer: negotiation.order.counter_offer,
                negotiation_request: negotiation.order.negotiation_request ?? activeOrder.negotiation_request ?? null,
            }),
        }
        : { id: 0, status: "pending" }
    // Customer asked to negotiate a pending order: it can't be accepted (or moved
    // forward) until the company counters, so only rejecting/cancelling is left.
    const negotiationRequestOpen = isNegotiationRequestOpen(orderToRender)
    const availableStatusOptions = useMemo<OrderStatus[]>(
        () => negotiationRequestOpen ? ["rejected", "cancelled"] : statusUpdateOptions[orderToRender.status] ?? [],
        [orderToRender.status, negotiationRequestOpen]
    )

    // The backend locks this in on the order itself at the moment it's
    // placed ("before_delivery" / "after_delivery"). Read it straight off
    // the order — never derive/cache it from the company's current setting,
    // since two orders from the same company can legitimately carry
    // different values if the setting was toggled in between.
    const paymentPreference = orderToRender.payment_preference

    // The backend blocks moving past "Accepted" while payment is pending for
    // companies that require payment before delivery.
    const isPaymentGateActive =
        paymentPreference === "before_delivery" && orderToRender.payment_status !== "paid"
    // Until the order has loaded we don't yet know its payment preference,
    // so treat gated statuses as locked to avoid a flash of enabled buttons.
    const isPaymentGateEffective = isPaymentGateActive || isOrderLoading

    useEffect(() => {
        if (availableStatusOptions.length === 0) {
            setSelectedStatus("")
            return
        }

        const defaultOption = isPaymentGateEffective
            ? availableStatusOptions.find((status) => !paymentGatedStatuses.has(status)) ?? availableStatusOptions[0]
            : availableStatusOptions[0]

        setSelectedStatus(defaultOption)
    }, [availableStatusOptions, isPaymentGateEffective])

    const getErrorMessage = (error: any, fallback: string) =>
        error?.data?.error?.message ?? error?.data?.message ?? error?.message ?? fallback

    const handleUpdateStatus = async () => {
        if (!selectedStatus || selectedStatus === orderToRender.status) return

        if (isPaymentGateEffective && paymentGatedStatuses.has(selectedStatus)) {
            toast.error(
                'This company requires payment before delivery. The order cannot move past "Accepted" until the customer has paid.'
            )
            return
        }

        try {
            await updateOrderStatus({
                id: orderId ?? String(orderToRender.id),
                status: selectedStatus,
            }).unwrap()
            toast.success("Order status updated successfully")
        } catch (error: any) {
            console.error("Failed to update order status", error)
            toast.error(getErrorMessage(error, "Failed to update order status"))
            // 400: e.g. the customer asked to negotiate. Load the current state.
            if (error?.status === 400) refetchOrder()
        }
    }

    const handleSelectHistory = (history: OrderHistoryEntry) => {
        setSelectedHistory(history)
        setMobileView("detail")
    }

    // Whose turn it is decides which buttons show; anything else gets a 400.
    const canRespondToPrice =
        isDayToDay && (orderToRender.status === "pending" || orderToRender.status === "customer_countered")
    const isAwaitingCustomer = isDayToDay && orderToRender.status === "counter_sent"
    const isNegotiationBusy = negotiation.isAccepting || negotiation.isRejecting
    const isRelocationOrder = orderToRender.order_type === "local_relocation" || orderToRender.order_type === "interstate_relocation"

    const handleReject = async () => {
        if (await negotiation.reject()) setShowRejectModal(false)
    }

    const RejectButton = () => (
        <button
            className="inline-flex items-center gap-1.5 rounded-lg border border-red-200 px-4 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-60"
            onClick={() => setShowRejectModal(true)}
            disabled={isNegotiationBusy}
        >
            <XCircle size={16} />
            Reject
        </button>
    )

    const StatusUpdater = () => (
        <div className="flex flex-wrap items-center gap-2">
            {isDayToDay && negotiation.loadErrorMessage ? (
                <div className="flex max-w-md flex-wrap items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
                    <AlertTriangle size={14} className="flex-shrink-0" />
                    <span className="min-w-0 flex-1">{negotiation.loadErrorMessage}</span>
                    <button
                        type="button"
                        onClick={() => negotiation.retryLoad()}
                        className="rounded-md border border-red-300 bg-white px-2 py-1 font-semibold hover:bg-red-100"
                    >
                        Retry
                    </button>
                </div>
            ) : canRespondToPrice && negotiationRequestOpen ? (
                <>
                    <p className="w-full text-xs font-medium text-purple-800">{negotiationHint(orderToRender.negotiation_request)}</p>
                    {/* With a proposed price, the company can accept it outright. */}
                    {orderToRender.negotiation_request?.proposed_price && (
                        <button
                            className="inline-flex items-center gap-1.5 rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60"
                            onClick={() => negotiation.accept()}
                            disabled={isNegotiationBusy || !negotiation.order}
                        >
                            <CheckCircle size={16} />
                            Accept {formatNaira(orderToRender.negotiation_request.proposed_price)}
                        </button>
                    )}
                    <button
                        className="inline-flex items-center gap-1.5 rounded-lg bg-[#143887] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#0f2f71] disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => setShowCounterModal(true)}
                        disabled={isNegotiationBusy || !negotiation.order}
                    >
                        <ArrowLeftRight size={16} />
                        Send counter offer
                    </button>
                    <RejectButton />
                </>
            ) : canRespondToPrice ? (
                <>
                    <button
                        className="inline-flex items-center gap-1.5 rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => negotiation.accept()}
                        disabled={isNegotiationBusy || !negotiation.order}
                    >
                        <CheckCircle size={16} />
                        {negotiation.priceOnTable ? `Accept ${formatNaira(negotiation.priceOnTable)}` : "Accept Order"}
                    </button>
                    <button
                        className="inline-flex items-center gap-1.5 rounded-lg bg-[#143887] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#0f2f71] disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => setShowCounterModal(true)}
                        disabled={isNegotiationBusy || !negotiation.order}
                    >
                        <ArrowLeftRight size={16} />
                        Negotiate
                    </button>
                    <RejectButton />
                </>
            ) : isAwaitingCustomer ? (
                <>
                    <div className="inline-flex items-center gap-2 rounded-full bg-amber-50 px-3 py-2 text-xs font-medium text-amber-700">
                        <span className="h-2 w-2 animate-pulse rounded-full bg-amber-500" />
                        Waiting for customer – you offered {formatNaira(orderToRender.counter_offer?.company_offered_price)}
                    </div>
                    <RejectButton />
                </>
            ) : availableStatusOptions.length > 0 ? (
                <>
                    {negotiationRequestOpen && (
                        <p className="w-full text-xs font-medium text-purple-800">
                            {NEGOTIATION_HINT}{" "}
                            {isRelocationOrder && (
                                <button
                                    type="button"
                                    onClick={() => navigate(`${FLEETRIFYROUTEPATH.RELOCATION_QUOTES}?order=${orderId ?? orderToRender.id}`)}
                                    className="font-semibold underline hover:text-purple-950"
                                >
                                    Open in Relocation Orders
                                </button>
                            )}
                        </p>
                    )}
                    <select
                        className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 outline-none focus:border-blue-500"
                        value={selectedStatus}
                        onChange={(event) => setSelectedStatus(event.target.value as OrderStatus)}
                    >
                        {availableStatusOptions.map((status) => {
                            const isGated = isPaymentGateEffective && paymentGatedStatuses.has(status)
                            return (
                                <option key={status} value={status} disabled={isGated}>
                                    {humanizeStatus(status)}
                                    {isGated ? " — Awaiting payment" : ""}
                                </option>
                            )
                        })}
                    </select>
                    <button
                        className="inline-flex items-center gap-2 rounded-lg bg-[#143887] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#0f2f71] disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={handleUpdateStatus}
                        disabled={
                            !selectedStatus ||
                            isUpdating ||
                            (isPaymentGateEffective && paymentGatedStatuses.has(selectedStatus))
                        }
                    >
                        <RefreshCw size={16} className={isUpdating ? "animate-spin" : ""} />
                        {isUpdating ? "Updating..." : "Update Status"}
                    </button>
                </>
            ) : (
                <div className="rounded-full bg-gray-100 px-3 py-2 text-xs font-medium text-gray-500">
                    {["delivered", "cancelled", "rejected"].includes(orderToRender.status)
                        ? "Status cannot be updated"
                        : "No update action available"}
                </div>
            )}
        </div>
    )

    const negotiationCard = (
        <>
            {orderToRender.negotiation_request && (
                <NegotiationRequestNotice request={orderToRender.negotiation_request} past={!showNegotiationBadge(orderToRender)} />
            )}
            {isDayToDay && negotiation.order && (
                <NegotiationCard
                    status={orderToRender.status}
                    price={negotiation.order.price}
                    counterOffer={negotiation.order.counter_offer}
                    negotiationRequest={orderToRender.negotiation_request}
                    originalPrice={negotiation.order.original_price}
                />
            )}
        </>
    )

    // Payment isn't due until both sides agree on a price, so skip the
    // banner while a day-to-day order is still open for negotiation.
    const isUnderNegotiation =
        isDayToDay && ["pending", "counter_sent", "customer_countered", "rejected", "cancelled"].includes(orderToRender.status)

    const PaymentGateBanner = () => {
        if (!isPaymentGateActive || isUnderNegotiation) return null

        return (
            <div className="mb-4 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
                <AlertTriangle size={18} className="mt-0.5 flex-shrink-0 text-amber-600" />
                <div>
                    <p className="text-sm font-semibold text-amber-800">Awaiting payment before delivery</p>
                    <p className="mt-0.5 text-xs text-amber-700">
                        This company requires payment before delivery, and this order is still marked{" "}
                        <span className="font-medium">{orderToRender.payment_status || "unpaid"}</span>. It can't move
                        past "Accepted" — In Progress, Picked Up, In Transit, Out for Delivery and Delivered are
                        locked — until the customer pays. This updates automatically as soon as payment is confirmed.
                    </p>
                </div>
            </div>
        )
    }

    const SidebarContent = () => (
        <>
            {/* Header */}
            <div className="px-4 pt-4">
                {/* <div className="flex items-center justify-between mb-4">
                    <div>
                        <p className="text-xs text-gray-400 mb-0.5">Orders</p>
                        <div className="flex items-center gap-2">
                            <span className="text-sm font-medium text-gray-800">Active Orders</span>
                            <span className="text-xs text-white px-2 py-0.5 rounded-full" style={{ background: BRAND }}>
                                {orders.length}
                            </span>
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <div className="text-center bg-gray-50 rounded-lg px-3 py-1.5">
                            <div className="text-sm font-medium" style={{ color: BRAND }}>
                                {orders.filter(o => o.status === "in_progress").length}
                            </div>
                            <div className="text-[10px] text-gray-400">In-transit</div>
                        </div>
                        <div className="text-center bg-gray-50 rounded-lg px-3 py-1.5">
                            <div className="text-sm font-medium text-green-700">
                                {orders.filter(o => o.status === "delivered").length}
                            </div>
                            <div className="text-[10px] text-gray-400">Done</div>
                        </div>
                    </div>
                </div> */}

                {/* Search */}
                {/* <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center flex-1 gap-2 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
                            <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
                        </svg>
                        <input
                            placeholder="Search orders..."
                            className="flex-1 bg-transparent outline-none text-sm placeholder:text-gray-400"
                        />
                    </div>
                    <button className="w-9 h-9 flex items-center justify-center border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2">
                            <line x1="4" y1="6" x2="20" y2="6" /><line x1="8" y1="12" x2="16" y2="12" /><line x1="11" y1="18" x2="13" y2="18" />
                        </svg>
                    </button>
                </div> */}

                {/* Filter tabs */}
                {/* <div className="flex gap-1.5 flex-wrap mb-3">
                    {filterTabs.map(tab => (
                        <button
                            key={tab}
                            onClick={() => setActiveFilter(tab)}
                            className="text-[11px] px-3 py-1 rounded-full border transition"
                            style={
                                activeFilter === tab
                                    ? { background: BRAND, color: "#fff", borderColor: BRAND }
                                    : { background: "transparent", color: "#6B7280", borderColor: "#E0E0E0" }
                            }
                        >
                            {tab}
                        </button>
                    ))}
                </div> */}
            </div>

            {/* History list */}
            <div className="flex-1 overflow-y-auto custom-scrollbar px-3 pb-3 space-y-2">
                {orderHistories.length > 0 ? (
                    orderHistories.map((history) => {
                        const isSelected = selectedHistory?.id === history.id
                        return (
                            <div
                                key={history.id}
                                onClick={() => handleSelectHistory(history)}
                                className="cursor-pointer rounded-lg p-3 transition space-y-2.5"
                                style={{
                                    border: isSelected ? `0.5px solid ${BRAND}` : "0.5px solid #E0E0E0",
                                    borderLeft: isSelected ? `3px solid ${BRAND}` : undefined,
                                    background: isSelected ? "#EEF4FF" : "#FAFAFA",
                                }}
                            >
                                <div className="flex justify-between items-center">
                                    <span className="text-sm font-medium text-gray-800">ID {activeOrder?.order_number || "N/A"}</span>
                                    <motion.span
                                        className={`text-[11px] font-medium px-2.5 py-0.5 rounded-full ${statusColors[history.status]} ${activeStatuses.has(history.status) ? "animate-badge-pulse" : ""}`}
                                        animate={activeStatuses.has(history.status) ? { opacity: [1, 0.6, 1] } : {}}
                                        transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
                                    >
                                        {humanizeStatus(history.status ?? "")}
                                    </motion.span>
                                </div>
                                <p className="text-xs text-gray-400">{(activeOrder?.order_type || "N/A").replace(/_/g, " ").replace(/\b\w/g, (char: string) => char.toUpperCase())}</p>
                                <div className="space-y-1.5">
                                    <div className="flex items-start gap-2 text-xs text-gray-500">
                                        <span className="w-2 h-2 rounded-full mt-0.5 flex-shrink-0" style={{ background: BRAND }} />
                                        <span>{formatTimeOnly(history.created_at)} · {history.pickup_location || activeOrder?.pickup_location || "Unknown pickup"}</span>
                                    </div>
                                    <div className="flex items-start gap-2 text-xs text-gray-500">
                                        <span className="w-2 h-2 rounded-full mt-0.5 flex-shrink-0 bg-green-700" />
                                        <span>{formatTimeOnly(history.created_at)} · {history.delivery_location || activeOrder?.delivery_location || "Unknown delivery"}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-6 text-center text-sm text-gray-500">
                        No order history is available for this order yet.
                    </div>
                )}
            </div>
        </>
    )

    return (
        <DashboardLayout
            title="View Order"
            pagePath={
                <div className="flex items-center gap-3">
                    {/* ── Back Button ── */}
                    <BackButton onClick={() => navigate(-1)} />

                    {/* Breadcrumb */}
                    <div className="hidden sm:flex items-center gap-1.5 text-sm text-gray-400">
                        <button onClick={() => navigate(-1)} className="hover:text-gray-600 transition cursor-pointer">
                            Orders
                        </button>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 18l6-6-6-6" />
                        </svg>
                        <span className="font-semibold" style={{ color: BRAND }}>View Order</span>
                    </div>
                </div>
            }
        >
            <FleetrifyCard cardContainerClass="mt-5 mb-10">

                {/*large screen*/}
                <div
                    className="hidden lg:grid"
                    style={{
                        gridTemplateColumns: "340px 1fr",
                        minHeight: 620,
                        borderRadius: 12,
                        overflow: "hidden",
                        border: "0.5px solid #E0E0E0",
                    }}
                >
                    {/* Sidebar */}
                    <div className="flex flex-col" style={{ borderRight: "0.5px solid #E0E0E0", background: "#fff" }}>
                        <SidebarContent />
                    </div>

                    {/* Detail panel */}
                    <div className="flex flex-col bg-white">
                        <div className="px-5 py-4 flex justify-between items-center" style={{ borderBottom: "0.5px solid #E0E0E0" }}>
                            <div>
                                <p className="text-xs text-gray-400 mb-1">Order details</p>
                                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                                    <span className="text-base font-medium text-gray-800 whitespace-nowrap">ID #{activeOrder?.order_number || "N/A"}</span>
                                    <motion.span
                                        className={`text-[11px] font-medium px-3 py-0.5 rounded-full ${statusColors[orderToRender.status]}`}
                                        animate={activeStatuses.has(orderToRender.status) ? { opacity: [1, 0.6, 1] } : {}}
                                        transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
                                    >
                                        {humanizeStatus(orderToRender.status ?? "")}
                                    </motion.span>
                                    {showNegotiationBadge(orderToRender) && <NegotiationRequestBadge />}
                                </div>
                            </div>
                            <StatusUpdater />
                        </div>
                        <div className="flex-1 overflow-y-auto custom-scrollbar p-5">
                            <PaymentGateBanner />
                            <OrderDetail order={orderToRender} histories={orderHistories} selectedHistory={selectedHistory} negotiation={negotiationCard} />
                        </div>
                    </div>
                </div>

                {/* MEDIUM SCREEN */}
                <div
                    className="hidden md:grid lg:hidden"
                    style={{
                        gridTemplateColumns: "280px 1fr",
                        minHeight: 580,
                        borderRadius: 12,
                        overflow: "hidden",
                        border: "0.5px solid #E0E0E0",
                    }}
                >
                    {/* Sidebar */}
                    <div className="flex flex-col" style={{ borderRight: "0.5px solid #E0E0E0", background: "#fff" }}>
                        <SidebarContent />
                    </div>

                    {/* Detail panel */}
                    <div className="flex flex-col bg-white">
                        <div className="px-4 py-3" style={{ borderBottom: "0.5px solid #E0E0E0" }}>
                            <div className="flex flex-col gap-3">
                                <div>
                                    <p className="text-xs text-gray-400 mb-1">Order details</p>
                                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                                        <span className="text-sm font-medium text-gray-800 whitespace-nowrap">ID #{activeOrder?.order_number || "N/A"}</span>
                                        <motion.span
                                            className={`text-[11px] font-medium px-2.5 py-0.5 rounded-full ${statusColors[orderToRender.status]}`}
                                            animate={activeStatuses.has(orderToRender.status) ? { opacity: [1, 0.6, 1] } : {}}
                                            transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
                                        >
                                            {humanizeStatus(orderToRender.status ?? "")}
                                        </motion.span>
                                        {showNegotiationBadge(orderToRender) && <NegotiationRequestBadge />}
                                    </div>
                                </div>
                                <StatusUpdater />
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto custom-scrollbar p-4">
                            <PaymentGateBanner />
                            <OrderDetail order={orderToRender} histories={orderHistories} selectedHistory={selectedHistory} negotiation={negotiationCard} />
                        </div>
                    </div>
                </div>

                {/*SMALL SCREEN */}
                <div
                    className="block md:hidden"
                    style={{
                        borderRadius: 12,
                        overflow: "hidden",
                        border: "0.5px solid #E0E0E0",
                        minHeight: 500,
                    }}
                >
                    {mobileView === "list" ? (
                        /* List view */
                        <div className="flex flex-col bg-white" style={{ minHeight: 500 }}>
                            <SidebarContent />
                        </div>
                    ) : (
                        /* Detail view */
                        <div className="flex flex-col bg-white">
                            {/* Mobile detail header with back-to-list */}
                            <div className="px-4 py-3 flex items-center gap-3" style={{ borderBottom: "0.5px solid #E0E0E0" }}>
                                <button
                                    onClick={() => setMobileView("list")}
                                    className="flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-white"
                                >
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={BRAND} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                <div className="flex-1">
                                    <p className="text-xs text-gray-400">Order details</p>
                                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-0.5">
                                        <span className="text-sm font-medium text-gray-800 whitespace-nowrap">ID #{activeOrder?.order_number || "N/A"}</span>
                                        <motion.span
                                            className={`text-[11px] font-medium px-2.5 py-0.5 rounded-full ${statusColors[orderToRender.status]}`}
                                            animate={activeStatuses.has(orderToRender.status) ? { opacity: [1, 0.6, 1] } : {}}
                                            transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
                                        >
                                            {humanizeStatus(orderToRender.status ?? "")}
                                        </motion.span>
                                        {showNegotiationBadge(orderToRender) && <NegotiationRequestBadge />}
                                    </div>
                                    <div className="mt-3">
                                        <StatusUpdater />
                                    </div>
                                </div>
                            </div>
                            <div className="p-4 overflow-y-auto custom-scrollbar">
                                <PaymentGateBanner />
                                <OrderDetail order={orderToRender} histories={orderHistories} selectedHistory={selectedHistory} negotiation={negotiationCard} />
                            </div>
                        </div>
                    )}
                </div>

            </FleetrifyCard>

            {showCounterModal && (
                <CounterOrderModal
                    customerName={orderToRender.customer?.name}
                    pickup={orderToRender.order_detail?.pickup_location ?? orderToRender.pickup_location}
                    destination={orderToRender.order_detail?.destination ?? orderToRender.delivery_location}
                    originalPrice={Number(negotiation.order?.price ?? 0)}
                    currentPrice={Number(negotiation.priceOnTable ?? 0)}
                    isCustomerCounter={orderToRender.status === "customer_countered"}
                    isSending={negotiation.isCountering}
                    onSubmit={negotiation.counter}
                    onClose={() => setShowCounterModal(false)}
                />
            )}

            {showRejectModal && (
                <RejectOrderModal
                    isLoading={negotiation.isRejecting}
                    onConfirm={handleReject}
                    onClose={() => setShowRejectModal(false)}
                />
            )}
        </DashboardLayout>
    )
}

export default ViewOrder